import React, { useState, useRef } from "react";
import { CRYPTO_SECRET_KEY, base_url } from "../utilities";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal'
import axios from "axios";
import { useNavigate } from "react-router";
import CryptoJS from "crypto-js";

export const ForgotPassword = (props) => {
    const navigate = useNavigate();
    let setModalShow = props.setModalShow
    let modalShow = props.modalShow
  
    const firstInputRef = useRef(null);
    const secondInputRef = useRef(null);
    const thirdInputRef = useRef(null);
    const fourthInputRef = useRef(null);
    const [spd,setSpd] = useState()
    const [timer,setTimer] = useState("10:00")  

    const [otpValue, setOtpValues] = useState({
      firstValue: '',
      secondValue: '',
      thirdValue: '',
      fourthValue: ''
    });

    const handleInput = (event, inputRef, prevInputRef) => {
      const input = event.target;
      const slicedVal = input.value.length>1? input.value.slice(0,1):input.value;
      const otpRegex = /^[0-9]*$/;
      if(input.value.length >1 ){
          const inputArray = Array.from(String(input.value),Number)
          let otpValueArray = ["firstValue","secondValue","thirdValue","fourthValue"]
          otpValueArray = otpValueArray.slice(otpValueArray.indexOf(input.name),otpValueArray.length )
          inputArray.map((i,index)=>{
            if (slicedVal === "" || otpRegex.test(i)) {
              if (prevInputRef && i === "") {
                prevInputRef.current.focus();
              } else if (inputRef && inputRef.current !== firstInputRef.current) {
                inputRef.current.focus();
              }
              setOtpValues((prevValues) => ({
                ...prevValues,
                [otpValueArray[index]]: i
              }));
            }
          })
      }
      else{
        if (slicedVal === "" || otpRegex.test(slicedVal)) {
          if (prevInputRef && slicedVal === "") {
            prevInputRef.current.focus();
          } else if (inputRef && inputRef.current !== firstInputRef.current) {
            inputRef.current.focus();
          }
          setOtpValues((prevValues) => ({
            ...prevValues,
            [input.name]: slicedVal
          }));
        }
      }
    };
  
  
  
    const [verificationCodeModalShow, setVerificationCodeModalShow] = React.useState(false);
    const [newPasswordModalShow, setNewPasswordModalShow] = React.useState(false);
    const handleCloseVerificationCode = () => {
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setOtpValues((prevValues) => ({
        ...prevValues,
        firstValue: '',
        secondValue: '',
        thirdValue: '',
        fourthValue: '',
      }));
      setVerificationCodeModalShow(false)
    };
    const handleCloseNewPassword = () => {
      setNewPasswordModalShow(false)
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setOtpValues((prevValues) => ({
        ...prevValues,
        firstValue: '',
        secondValue: '',
        thirdValue: '',
        fourthValue: '',
      }));
      setError('');
    };

    const setExpiryTimer = (t) => {
      
       setSpd(setInterval(() => {
        t = t - 1
        if(t<0){
          clearInterval(spd)
        }
        else{
          let minutes = Math.floor(t / 60);
        if(minutes<10) minutes = "0"+minutes
        let seconds = t - minutes * 60;
        if(seconds<10) seconds = "0"+seconds
        setTimer(minutes+":"+seconds)
        }
        
      }, 1000))
    }
  
  
    const firstCloseSecondOpen = () => {   
      if (email !== '') {
        axios
          .post(base_url + "user/reset_password", {
            "email": email
          })
          .then((res) => {
            if (res.data.message == "The verification code has been sent") {
              toast.success("The verification code has been sent", {
                toastId: 19
              })
              setOtpValues({
                firstValue: '',
                secondValue: '',
                thirdValue: '',
                fourthValue: ''
              })
              clearInterval(spd)
              setModalShow(false)
              setVerificationCodeModalShow(true)
              setExpiryTimer(600)
            }
            else {
              toast.error('Invalid email. Please enter a valid one.', {
                toastId: 15
              })
            }
  
          })
      }
    }
    const secondCloseThirdOpen = () => {
      let final_verfication_code = (otpValue.firstValue) + (otpValue.secondValue) + (otpValue.thirdValue) + (otpValue.fourthValue)
      axios
        .post(base_url + "user/verify/code", {
          "verification_code": Number(final_verfication_code),
          "email": email
        })
        .then((res) => {
          if (res.data.message == "Verified") {
            
            toast.success("Successfully verified", {
              toastId: 18
            })
            setTimeout(() => {
              setVerificationCodeModalShow(false)
              setNewPasswordModalShow(true)
            }, 1000);
          }
          else if (res.data.message == "OTP Expired.") {
            toast.error("OTP time Expired,Please resend it.", {
              toastId: 11
            })
          }
          else {
            toast.error("Invalid verification code", {
              toastId: 4
            })
          }
        })
    }
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [enterPassword, setEnterPassword] = useState('')
    const [confirmPwd, setConfirmPwd] = useState('')
  
  
    const handleChangePassword = (e) => {
      let value = e.target.value;
      let name = e.target.name;
    
      if (name === "password") {
        if (value !== '' || value !== undefined) { 
          const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+~\-={}\[\]|\\:;"'<>,.?/]).{8,}$/;
          if (regex.test(value)) {
            setEnterPassword(value) 
          }
        }
      }
      if (name === "confirmpassword") {
        if (value !== '' || value !== undefined) { setConfirmPwd(value) }
      }
    }
    const [email, setEmail] = useState('');
  
    const handleEmailChange = (e) => {
      setEmail(e.target.value);
  
    };
  
    const handlePwdSuccess = (event) => {
      if (password !== confirmPassword) {
        setError('Passwords do not match');
      }

      else {
        setEnterPassword(CryptoJS.AES.encrypt(
          enterPassword,
          CRYPTO_SECRET_KEY
        ).toString());
        setConfirmPwd(CryptoJS.AES.encrypt(
          confirmPwd,
          CRYPTO_SECRET_KEY
        ).toString())
        axios
          .post(base_url + "password/update/initial/onborading", {
            "email": email,
            "password": enterPassword
          })
          .then((res) => {
            if (res.data.message = "Successfully updated") {
              toast.success("Successfully updated", {
                toastId: 4
              })
              handleCloseNewPassword()
              setTimeout(() => {
                window.location.reload();
              });
              navigate("/");
            }
            else {
              toast.error("error occured try after sometime", {
                toastId: 4
              })
              
            }
          })
      }
    
    }
  
  
  
    const handleClose = () => {
      setEmail('')
      setModalShow(false)
      if (modalShow == false) {
        setEmail('')
      }
    };
  
    return (
      <div>
  
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          keyboard={false}
          className=""
          show={modalShow}
          onHide={handleClose}
        >
  
  
          <Modal.Body className="forgot_pwd_main">
            <h5 >Reset Password</h5>
            <p style={{fontSize:"13px",marginTop:"5px"}}>Verification code will be sent to your registered email ID</p>
            <Form>
              <Form.Group className="mb-3 mt-4" controlId="exampleForm.ControlInput1">
                <Form.Label >Email </Form.Label>
                <Form.Control className="input_email" type="email" autoFocus placeholder="Enter your email " value={email}
                  onChange={handleEmailChange} />
              </Form.Group>
            </Form>
            <div className='reset_btn_div'><button onClick={firstCloseSecondOpen} className=" reset_btn mt-3" disabled={email !== '' ? false : true}><div className="reset_txt" >Reset Password</div></button></div>
  
  
            <div className="sesam_color_backto w-50 m-auto mt-4" onClick={handleClose}><img src="./images/sesameleftarrow.svg" alt="" /> Back to login</div>
          </Modal.Body>
  
  
        </Modal>
  
  
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          className=""
          show={verificationCodeModalShow}
          onHide={handleCloseVerificationCode}
        >
  
          <i className="fa-sharp fa-solid fa-xmark new_password_crossmark" onClick={handleCloseVerificationCode}></i>
          <Modal.Body className="forgot_pwd_main">
            <h5 >Enter Verification Code</h5>
            <p style={{fontSize:"13px",marginTop:"5px"}}>Enter 4 digit code that you received on your email ID</p>
  
            <div className="d-flex opt_field_boxes">
              <input
                type="number"
                name="firstValue"
                value={otpValue.firstValue.length>1?otpValue.firstValue.slice(0,1):otpValue.firstValue}
                autoFocus
                max={1}
                ref={firstInputRef}
                tabIndex={1}
                onChange={(e) => handleInput(e, secondInputRef, firstInputRef)}
                onKeyDown={(e) => {
                  const isDigit = /\d/.test(e.key);
                  const isEmpty = e.target.value === "";
                  const isBackspace = e.key === "Backspace";
                  const isDelete = e.key === "Delete";
                  if ((isEmpty && !isDigit) || (e.target.value.length >= 1 && !isDigit && !isBackspace && !isDelete)) {
                    // e.preventDefault();
                  }
                }}
              />
              <input
                type="number"
                name="secondValue"
                tabIndex={2}
                value={otpValue.secondValue.length>1?otpValue.secondValue.slice(0,1):otpValue.secondValue}
                max={1}
                ref={secondInputRef}
                onChange={(e) => handleInput(e, thirdInputRef, firstInputRef)}
                onKeyDown={(e) => {
                  const isDigit = /\d/.test(e.key);
                  const isEmpty = e.target.value === "";
                  const isBackspace = e.key === "Backspace";
                  const isDelete = e.key === "Delete";
                  if ((isEmpty && !isDigit) || (e.target.value.length >= 1 && !isDigit && !isBackspace && !isDelete)) {
                    // e.preventDefault();
                  }
                }}
              />
              <input
                type="number"
                name="thirdValue"
                max={1}
                tabIndex={3}
                value={otpValue.thirdValue.length>1?otpValue.thirdValue.slice(0,1):otpValue.thirdValue}
                ref={thirdInputRef}
                onChange={(e) => handleInput(e, fourthInputRef, secondInputRef)}
                onKeyDown={(e) => {
                  const isDigit = /\d/.test(e.key);
                  const isEmpty = e.target.value === "";
                  const isBackspace = e.key === "Backspace";
                  const isDelete = e.key === "Delete";
                  if ((isEmpty && !isDigit) || (e.target.value.length >= 1 && !isDigit && !isBackspace && !isDelete)) {
                    // e.preventDefault();
                  }
                }}
              />
              <input
                type="number"
                name="fourthValue"
                value={otpValue.fourthValue.length>1?otpValue.fourthValue.slice(0,1):otpValue.fourthValue}
                max={1}
                tabIndex={4}
                ref={fourthInputRef}
                onKeyDown={(e) => {
                  const isDigit = /\d/.test(e.key);
                  const isEmpty = e.target.value === "";
                  const isBackspace = e.key === "Backspace";
                  const isDelete = e.key === "Delete";
                  if ((isEmpty && !isDigit) || (e.target.value.length >= 1 && !isDigit && !isBackspace && !isDelete)) {
                    // e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const newValue = e.target.value.slice(0, 1);
                  e.target.value = newValue;
                  handleInput(e, null, thirdInputRef);
                }}
              />
            </div>
  
            <div>
              <h6 style={{textAlign:"center"}}>OTP expires in : {timer}</h6>
            </div>
            <div className="resend_otp_txt" style={{fontSize:"12px"}}>If you didn’t receive a code<strong className="resend_style" onClick={firstCloseSecondOpen} style={{fontSize:"12px"}}>Resend</strong></div>
            <div className="m-auto d-flex justify-content-center"><button className="reset_btn w-50 " onClick={secondCloseThirdOpen}
              disabled={otpValue.firstValue !== '' && otpValue.secondValue !== '' && otpValue.thirdValue !== '' && otpValue.fourthValue !== '' ? false : true}
            >
              Submit</button></div>
  
          </Modal.Body>
  
        </Modal>
  
  
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          className="reset_third_modal"
          show={newPasswordModalShow}
          onHide={handleCloseNewPassword}
        >
  
  
          <i className="fa-sharp fa-solid fa-xmark new_password_crossmark" onClick={handleCloseNewPassword}></i>
          <Modal.Body className="forgot_pwd_main" style={{ height: "320px" }} >
            <Form >
              <Form.Group className="mb-3 " controlId="passwordInput">
                <Form.Label>Enter new password</Form.Label>
                <Form.Control className="input_email" type={showPassword ? 'text' : 'password'} name="password" placeholder="Password"  onChange={handleChangePassword} />
              </Form.Group>
              <Form.Group className="mt-3" controlId="confirmPasswordInput">
                <Form.Label>Confirm password</Form.Label>
                <div className="confirm_pwd_hide_icon">
                  <Form.Control className="input_email" type={showPassword ? 'text' : 'password'} name="confirmpassword" placeholder="Confirm password"  onChange={handleChangePassword} />
                  {/* <img src="./images/hidepassword.svg" alt="" className="hide_pwd_icon" onClick={handleToggleShowPassword} /> */}
                </div>
              </Form.Group>
              <div className='reset_password_const ' >
              <span style={{fontSize:"13px"}} className="passwd_crit_reset">The password should meet the following criteria:</span>
              <ul >
                <li style={{fontSize:"10px"}}>should be at least 8 characters long</li>
                <li style={{fontSize:"10px"}}>contain at least 1 number.</li>
                <li style={{fontSize:"10px"}}>contain at least 1 uppercase character.</li>
                <li style={{fontSize:"10px"}}>contain at least 1 lowercase character.</li>
                <li style={{fontSize:"10px"}}>contain at least 1 symbol.</li>
              </ul>
  
              </div>
              {/* <div>{error && <p className="text-danger">{error}</p>}</div> */}
              <div className="newpswd_btn_styl"><button className=" orange_btn " disabled={enterPassword !== '' && enterPassword === confirmPwd ? false : true} onClick={handlePwdSuccess}>Submit</button></div>
  
            </Form>
  
  
          </Modal.Body>
  
        </Modal>
  
      </div>
    );
  };
  